<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";

    import Icon from "@components/Icon.svelte";

    import { videoControllerToken } from "./context_tokens";
    import VideoPlayerFullscreenIcon from "./icons/VideoPlayerFullscreenIcon.svelte";
    import VideoPlayerUIButton from "./VideoPlayerUIButton.svelte";

    const videoController = getTypedContext(videoControllerToken);

    let fullscreenEnabled = videoController.fullscreen$;
    const toggleFullscreen = () => {
        if (fullscreenEnabled.getValue()) {
            videoController.leaveFullscreen();
        } else {
            videoController.enterFullscreen();
        }
    };
</script>

<VideoPlayerUIButton on:click={toggleFullscreen}>
    <Icon height="1.5rem" width="1.5rem">
        <VideoPlayerFullscreenIcon />
    </Icon>
</VideoPlayerUIButton>
